<template>
  <div class="area-chart-container">
    <VueApexCharts type="area" :options="options" :series="chartSeries" />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import numberUtils from '@/utils/numberUtils';

export default {
  mixins: [numberUtils],
  name: 'AreaChart',
  props: ['series', 'categories', 'colors', 'dayChart'],
  components: {
    VueApexCharts,
  },
  created() {
    this.updateChartData();
    this.updateChartSeries();
  },
  data() {
    return {
      options: {},
      chartSeries: {},
    };
  },
  methods: {
    updateChartData() {
      this.options = {
        chart: {
          id: 'area-chart',
          height: 400,
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fas fa-download"></i>',
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.7,
          },
        },
        stroke: {
          curve: 'straight',
        },
        colors: this.colors,
        tooltip: {
          x: {
            show: false,
            format: 'dd/MM/yyyy HH:mm',
          },
        },
        xaxis: {
          type: 'datetime',
          categories: this.categories,
          labels: {
            datetimeFormatter: {
              year: 'yyyy',
              month: 'dd/MM/yy',
              day: 'dd/MM/yyyy',
              hour: 'HH:mm',
            },
          },
        },
        yaxis: {
          forceNiceScale: true,
          decimalsInFloat: 2,
          min: 0,
          labels: {
            formatter: value => this.numberWithCommas(value),
          },
        },
        responsive: [{
          breakpoint: 575.98,
          options: {
            chart: {
              height: 220,
              toolbar: {
                show: false,
              },
            },
            stroke: {
              width: 1,
            },
            yaxis: {
              labels: {
                maxWidth: 40,
                formatter: value => this.transformUnit(value),
              },
            },
          },
        }],
      };
    },
    updateChartSeries() {
      this.chartSeries = this.series;
    },
  },
  watch: {
    async series() {
      await this.updateChartSeries();
    },
    async categories() {
      await this.updateChartData();
    },
    async colors() {
      await this.updateChartData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
